import { useCallback, useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { layoutStore, selectFullscreen } from '../store/layout.store';
import {
    exitFullscreen,
    getFullscreenElement,
    getVendorPrefixes,
    requestFullscreen,
} from '../utils/fullscreen';

export function useFullscreen() {
    const dispatch = useDispatch();
    const setFullscreen = useCallback(
        (isFullscreen: boolean) => {
            if (isFullscreen) {
                requestFullscreen(document.body);
            } else {
                exitFullscreen();
            }
            dispatch(layoutStore.actions.setFullscreen(isFullscreen));
        },
        [dispatch],
    );
    const isFullscreen = useSelector(selectFullscreen);

    useEffect(() => {
        const prefixes = getVendorPrefixes();

        if (!prefixes) {
            // No support for the event.
            return;
        }

        const onChange = () => {
            if (getFullscreenElement() !== document.body) {
                dispatch(layoutStore.actions.setFullscreen(false));
            }
        };
        const changeEvent = prefixes.events.change;
        document.body.addEventListener(changeEvent, onChange);

        return () => {
            document.body.removeEventListener(changeEvent, onChange);
        };
    }, [dispatch]);

    return useMemo(
        () => ({
            setFullscreen,
            isFullscreen: isFullscreen,
        }),
        [setFullscreen, isFullscreen],
    );
}
